// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Afidium
import { TextFieldComponent } from './text-field.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
    ],
    declarations: [
        TextFieldComponent
    ],
    exports: [
        TextFieldComponent
    ]
})
export class TextFieldModule { }
